const messages: Record<string, string> = {
	'blockedByDevice.headline': 'Uporabite pametni telefon',
	'blockedByDevice.paragraph.first': 'To povezavo je mogoče uporabiti samo na pametnih telefonih.',
	'blockedByDevice.paragraph.second':
		'Hiter nasvet: ko odprete povezavo, bodite v bližini vozila in imejte pripravljene dokumente.',
	'button.continue': 'Nadaljuj',
	'button.next': 'Nadaljuj',
	'review.button.next': 'Zaključi',
	'button.photo.take': 'Fotografiraj',
	'onboardingStart.headline': 'Pozdravljeni! Preverite svoje podatke, da lahko začnemo.',
	'onboardingStart.plateNumber': 'Registrska oznaka:',
	'onboardingStart.timeout': 'Ta povezava bo aktivna do ',
	'button.start': 'Začni',
	poweredBy: 'Omogoča <ce>ControlExpert</ce>, podjetje skupine <solvd>Solvd</solvd>',
	'onboarding.headline': 'Ste pripravljeni začeti digitalni pregled?',
	'onboarding.paragraph': 'Pred začetkom postopka upoštevajte naslednje:',
	'onboarding.documents': 'Imejte pri roki ključe in prometno dovoljenje vozila.',
	'onboarding.camera': 'Fotografije je mogoče posneti samo s kamero pametnega telefona.',
	'onboarding.internet': 'Bodite na mestu z dobro osvetlitvijo in močno internetno povezavo.',
	'onboarding.vehicle':
		'Zagotovite, da je vozilo čisto, dostopno z vseh strani in da so vsa okna zaprta.',
	'onboarding.terms.before': 'Pred začetkom potrdite naslednje:',
	'onboarding.terms.url': 'Strinjam se s pogoji uporabe.',
	'vehicleFrontLeftPerspectiveImage.title': 'Fotografija vozila spredaj levo',
	'vehicleFrontLeftPerspectiveImage.description':
		'Fotografirajte vozilo s sprednje leve diagonale in zagotovite, da je celotno vozilo v kadru ter da je registrska tablica vidna.',
	'vehicleRearLeftPerspectiveImage.title': 'Fotografija vozila zadaj levo',
	'vehicleRearLeftPerspectiveImage.description':
		'Fotografirajte vozilo z zadnje leve diagonale in zagotovite, da je celotno vozilo v kadru ter da je registrska tablica vidna.',
	'vehicleRearRightPerspectiveImage.title': 'Fotografija vozila zadaj desno',
	'vehicleRearRightPerspectiveImage.description':
		'Fotografirajte vozilo z zadnje desne diagonale in zagotovite, da je celotno vozilo v kadru ter da je registrska tablica vidna.',
	'vehicleFrontRightPerspectiveImage.title': 'Fotografija vozila spredaj desno',
	'vehicleFrontRightPerspectiveImage.description':
		'Fotografirajte vozilo s sprednje desne diagonale in zagotovite, da je celotno vozilo v kadru ter da je registrska tablica vidna.',
	'windshieldImage.title': 'Fotografija vetrobranskega stekla',
	'windshieldImage.description':
		'Fotografirajte vetrobransko steklo in zagotovite, da so celotna steklena površina in njene podrobnosti jasno vidne.',
	'vinPicture.title': 'Fotografija številke šasije',
	'vinPicture.description':
		'Poslikajte od blizu območje s številko šasije (VIN) in zagotovite, da so vsi znaki berljivi.',
	'button.hint': 'Kje se nahaja številka šasije?',
	'photo.deleteConfirmation.title': 'Ali ste prepričani, da želite izbrisati fotografijo?',
	'photo.deleteConfirmation.description': 'Če izbrišete fotografijo, boste morali posneti novo.',
	'photo.deleteConfirmation.cancel': 'Prekliči',
	'photo.deleteConfirmation.confirm': 'Izbriši fotografijo',
	'hint.vin.title': 'Možne lokacije številke šasije',
	'hint.vin.description': 'Običajno jo najdete na enem od teh 4 mest:',
	'hint.vin.location1': 'Na armaturni plošči, vidna skozi vetrobransko steklo na voznikovi strani.',
	'hint.vin.location2': 'Na okvirju vrat na voznikovi strani, blizu zapaha.',
	'hint.vin.location3': 'V motornem prostoru, pogosto na kovinski ploščici.',
	'hint.vin.location4': 'Na sprednjem delu okvirja (starejša vozila).',
	'overallDashboardImage.title': 'Slika celotne armaturne plošče',
	'overallDashboardImage.description':
		'Fotografirajte celotno armaturno ploščo in zagotovite, da so vse kontrolne lučke in funkcije v celoti vidne.',
	'dashboardMileage.title': 'Fotografija števca kilometrov',
	'vehicleMileage.description':
		'Fotografirajte števec kilometrov in zagotovite, da je digitalni prikaz ostro fokusiran in v celoti berljiv.',
	'dashboardMileage.paragraph.first': 'Vnesite prevožene kilometre vozila.',
	'dashboardMileage.placeholder.updated': 'vnesite prevožene kilometre (km)',
	'damageImages.title': 'Fotografije poškodb',
	'damageImages.booleanRadioGroupLabel': 'Ali je vaše vozilo poškodovano?',
	'damageImages.description': 'Dodate lahko največ 4 fotografije.',
	'damageImages.booleanRadioGroupLabelLeft': 'Ne',
	'damageImages.booleanRadioGroupLabelRight': 'Da',
	'thanks.headline.first': 'Fotografije uspešno prejete!',
	'thankYou.message': 'Vašo zahtevo pregleduje naša tehnična ekipa.',
	'feedback.title': 'Cenili bi vaše mnenje.',
	'feedback.message':
		'Na lestvici od 0 do 5, kako bi ocenili svojo izkušnjo z digitalnim pregledom pri nas?',
	'feedback.helpImprove': 'Pomagajte nam izboljšati storitev (neobvezno):',
	'feedback.button.send': 'Pošlji mnenje',
	'feedback.error.maxLength': 'Povratna informacija ne sme presegati 500 znakov.',
	'review.title': 'Povzetek vašega digitalnega pregleda',
	'review.paragraph.first':
		'Pred zaključkom preverite, ali so vsi podatki pravilni.<br/><br/>Po kliku na »Zaključi« bomo potrdili vaše fotografije in podatke.',
	'review.stepDescription.questions': 'Podatki o vozilu',
	'review.stepDescription.group.perspectiveImages': 'Fotografije vozila',
	'review.stepDescription.group.additionalImages': 'Dodatne fotografije',
	'review.stepDescription.damageImages': 'Fotografije poškodb',
	'review.stepDescription.vehicleFrontLeftPerspective': 'Fotografija vozila spredaj levo',
	'review.stepDescription.vehicleRearLeftPerspective': 'Fotografija vozila zadaj levo',
	'review.stepDescription.vehicleRearRightPerspective': 'Fotografija vozila zadaj desno',
	'review.stepDescription.vehicleFrontRightPerspective': 'Fotografija vozila spredaj desno',
	'review.stepDescription.windshield': 'Fotografija vetrobranskega stekla',
	'review.stepDescription.vinPicture': 'Fotografija številke šasije',
	'review.stepDescription.overallDashboard': 'Slika celotne armaturne plošče',
	'review.stepDescription.mileage': 'Fotografija števca kilometrov',
	'review.stepDescription.fourAdditionalDocuments': 'Dodatne fotografije',
	'timeout.headline.first': 'Zahtevani primer ni bil najden.',
	'timeout.paragraph.first':
		'Vaš primer je potekel ali pa je povezava, do katere ste dostopali, napačna.',
	'photoUploading.title': 'Nalaganje',
	'photoAnalyzing.title': 'Analiziranje',
	'photoLoading.title': 'Nalaganje',
	'camera.darkWarning':
		'Okolica je morda pretemna – za boljšo kakovost fotografij izboljšajte osvetlitev.',
	'landscapeModeDetected.title': 'Samodejno vrtenje omogočeno',
	'landscapeModeDetected.text':
		'Za boljšo izkušnjo s kamero onemogočite samodejno vrtenje na vaši napravi.',
	'validationContainer.correct': 'Pravilno',
	'button.changeImage': 'Zamenjaj fotografijo',
	'button.acceptImage': 'Sprejmi fotografijo',
	'button.acceptMileage': 'Pravilno',
	'button.anotherImage': 'Posnemi drugo fotografijo',
	'invalidFile.size.title': 'Nepravilna velikost fotografije',
	'invalidFile.size.description': 'Velikost fotografije presega največjo dovoljeno.',
	'invalidFile.extension.title': 'Vrsta datoteke ni podprta',
	'invalidFile.extension.description':
		'Navedena vrsta datoteke ni podprta. Podprte vrste datotek: .jpg, .jpeg, .jfif, .heic, .heif, .png in .bmp.',
	'connectionError.title': 'Napaka pri povezavi',
	'connectionError.description': 'Napaka pri povezavi. Prosimo, naložite fotografijo ponovno.',
	'missingPhoto.title': 'Manjkajoča fotografija',
	'missingPhoto.description':
		'Zdi se, da manjka fotografija. Za nadaljevanje dodajte manjkajočo fotografijo.',
};

export default messages;
